angular.module('bringgApp.filters').filter('groupBy', function () {
	return function (list, group_by) {
		return _.groupBy(list, group_by);
	};
});
